import { Guid, Nillable } from '@web/utils';
import { AdminBoxSaleGroups } from './admin-box-sale-details-form';
import { AdminBoxSaleVariant } from './admin-box-sale-variant';

export class AdminBoxSaleDetails {
  public constructor(
    private readonly data: {
      description?: Nillable<string>;
      groups: AdminBoxSaleGroups;
      id: Guid;
      validityHours: number;
      variants: AdminBoxSaleVariant[];
    },
  ) {}

  public get description(): Nillable<string> {
    return this.data.description;
  }

  public get groups(): AdminBoxSaleGroups {
    return this.data.groups;
  }

  public get id(): Guid {
    return this.data.id;
  }

  public get validityHours(): number {
    return this.data.validityHours;
  }

  public get variants(): AdminBoxSaleVariant[] {
    return this.data.variants;
  }
}
